import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Image, Text } from "@chakra-ui/react";
import { TfiMenu } from "react-icons/tfi";

import SidebarItem from "./SidebarItem";
import sidebarItems from "./SidebarItems";

function Sidebar() {
  const location = useLocation().pathname;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [sidebarWidth, setSidebarWidth] = useState<number | string>(300);
  const [sidebarHeight, setSidebarHeight] = useState("100%");
  const isMobile = windowWidth <= 768;

  const [minimize, setMinimize] = useState(false);
  const [show, setShow] = useState(true);

  function handleToggle() {
    if (isMobile) {
      setShow(!show);
    } else {
      setMinimize(!minimize);
    }
  }

  // Setup resize event listener
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 768) {
        setShow(false);
        setMinimize(false);
      } else {
        setShow(true);
      }

      setWindowWidth(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Set sidebar width and height on resize
  useEffect(() => {
    if (isMobile) {
      setSidebarWidth("100%");

      if (show) {
        setSidebarHeight("100vh");
      } else {
        setSidebarHeight("100%");
      }
    } else {
      setSidebarWidth(300);
    }
  }, [windowWidth, show]);

  useEffect(() => {
    if (!isMobile) {
      if (minimize) {
        setSidebarWidth(70);
      } else {
        setSidebarWidth(300);
      }
    }
  }, [minimize]);

  // Hide sidebar when a link is clicked on mobile
  useEffect(() => {
    if (windowWidth <= 768) {
      setShow(false);
    }
  }, [location]);

  return (
    <div style={{ ...styles.sidebar, width: sidebarWidth, height: sidebarHeight }}>
      <div style={{ ...styles.header, flexDirection: minimize ? "column" : "row" }}>
        <Image boxSize={55} src="https://i.ibb.co/kBKkcjp/going-solo-logo.png" alt="Logo" style={{ marginLeft: isMobile || !minimize ? 7.5 : 0 }} />

        {!minimize && <Text fontSize={20} color={"white"} fontWeight={600}>
          Going Solo
        </Text>}

        <div style={{ padding: "0 15px" }}>
          <TfiMenu
            size="24px"
            cursor="pointer"
            color="white"
            onClick={handleToggle}
          />
        </div>
      </div>

      {show && (
        <div style={{ marginTop: 20, width: "100%" }}>
          {!minimize && (
            <Text ps='4' fontSize='xl' color='white' mb={3}>
              Menu Items
            </Text>
          )}

          <div style={{ height: 500 }}>
            {sidebarItems?.map((item: any, index: number) => (
              <SidebarItem
                key={index}
                minimize={minimize}
                title={item.title}
                link={item.link}
                icon={item.icon}
                subMenu={item?.subMenu}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  sidebar: {
    backgroundColor: "#0987A0",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 20,
    marginTop: 10,
    marginBottom: 10,
    width: "100%",
  },
  }

export default Sidebar;
